import * as React from "react";
import { Typography } from "@material-ui/core";
import withStyles, { WithStyles } from "@material-ui/core/styles/withStyles";
import { styles } from "./Conditions.style";

interface ConditionsProps {
    list: string[];
}

class Conditions extends React.Component<ConditionsProps & WithStyles<typeof styles>> {

    public render() {

        const classes = this.props.classes;

        return (
            <>
                <Typography variant="subheading" component="h3" className={classes.title}>Admissibilité du contrat :</Typography>
                {this.props.list.map((condition, index) => (
                    <Typography className={classes.item} key={index} dangerouslySetInnerHTML={{__html: "+ " + condition }}/>)
                )}

            </>
        );
    }

}

export default withStyles(styles)(Conditions);


// WEBPACK FOOTER //
// ./src/components/Conditions/Conditions.tsx